import { makeStyles } from 'tss-react/mui';
import { ESProductColor } from '../../../../products/ProductTypes';

export const getColorStyles = (color: ESProductColor) =>
  color.imageUrl
    ? { backgroundImage: `url(${color.imageUrl})`, backgroundSize: 'cover' }
    : { backgroundColor: color.hexcode };

export const useOrderProductStyles = makeStyles()((theme) => ({
  divider: {
    borderTop: `1px solid ${theme.palette.grey[200]}`,
  },
  root: {
    minHeight: 92,
    padding: `0px ${theme.spacing(3)}`,
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
      padding: `${theme.spacing(1)} 0px`,
    },
  },

  gridCell: {
    width: 440,
    overflowX: 'auto',
    [theme.breakpoints.up('xl')]: {
      width: 600,
    },
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
      overflowY: 'hidden',
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      width: 'auto',
    },
  },
  touchGridHeight: {
    height: theme.spacing(14.5),
    [theme.breakpoints.up('lg')]: {
      height: theme.spacing(18),
    },
  },
  totalsCell: {
    width: 225,
    [theme.breakpoints.up('lg')]: {
      width: 'auto',
      maxWidth: 250,
    },
  },
  productCell: {
    width: 240,
    [theme.breakpoints.up('xl')]: {
      width: 266,
    },
    [theme.breakpoints.down('xl')]: {
      width: 236,
    },
  },
  colorCell: {
    width: 100,
    [theme.breakpoints.up('xl')]: {
      width: 206,
    },
    [theme.breakpoints.down('xl')]: {
      width: 196,
    },
  },
  deliveryWindowCell: {
    width: 160,
    [theme.breakpoints.up('xl')]: {
      width: 206,
    },
    [theme.breakpoints.down('xl')]: {
      width: 196,
    },
  },
  endActionsCell: {
    width: 170,
    [theme.breakpoints.down('xl')]: {
      width: 150,
    },
  },
  overflowTooltip: {
    fontWeight: 600,
    fontSize: theme.spacing(2),
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  smallOverflowTooltip: {
    fontWeight: 600,
    fontSize: theme.spacing(5 / 3),
  },
  code: {
    fontSize: theme.spacing(5 / 3),
  },
  productName: {
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
  productNameWithoutHover: {
    color: theme.palette.text.primary,
  },
  colorBadge: {
    width: 16,
    height: 16,
    flexShrink: 0,
    borderRadius: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
  },
  colorInput: {
    '& .MuiAutocomplete-endAdornment': {
      right: `${theme.spacing(0.5)} !important`,
    },
    '& .MuiInputBase-input': {
      minWidth: theme.spacing(6),
    },
  },
  deleteIcon: {
    color: theme.palette.error.light,
  },
  tooltipTablePadding: {
    '& td, th': {
      paddingRight: theme.spacing(1),
    },
  },
  orderItemProgressStatus: {
    '& div': {
      fontSize: 13,
    },
  },
  label: {
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    lineHeight: '17px',
  },

  breakedLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    WebkitLineClamp: 2,
    lineHeight: '17px',
  },
  productAndColorCode: {
    paddingTop: theme.spacing(1 / 2),
    lineHeight: '17px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
}));
